import styled, { css } from 'styled-components';
import {
  AMZ_SUCCESS,
  NATIVE_GREY,
  NEGATIVE_100,
  NEGATIVE_500,
  NEGATIVE_700,
  NEUTRAL_500,
  POSITIVE_500,
  PRIMARY_100,
  PRIMARY_500,
  TERTIARY_500,
  WHITE,
} from '../../styles/colors';
import {
  FONT_WEIGHT_BOLD,
  FONT_WEIGHT_LIGHT,
  FONT_WEIGHT_NORMAL,
  FONT_WEIGHT_REGULAR,
} from '../../styles/typography';
import { isAmazonHost } from '../../utils';

export const Cards = styled.div`
  &&& {
    .disabled {
      pointer-events: none;
      cursor: default;
      opacity: 0.7;
    }

    .card-column {
      min-width: 295px;
      ${() =>
        !isAmazonHost() &&
        css`
          max-width: 385px;
          min-width: 350px;
          @media only screen and (max-width: 430px) {
            min-width: 100%;
          }
        `};

      :only-child {
        @media (orientation: landscape) {
          button {
            width: auto;
          }
        }
      }
    }

    ${() =>
      isAmazonHost() &&
      css`
        & > div {
          & h4 {
            font-size: 18px !important;
            line-height: 22px !important;
            margin: 0;
            ${FONT_WEIGHT_BOLD};
          }

          & p {
            font-size: 15px !important;
            line-height: 21px !important;
            ${FONT_WEIGHT_NORMAL};
          }
        }
      `}
  }
`;

export const StyledCard = styled.div`
  &&& {
    border-radius: 8px;
    border: 1px solid ${TERTIARY_500};
    font-size: 14px;
    ${FONT_WEIGHT_LIGHT};
    background-color: ${WHITE};
    height: 100%;

    p {
      margin-bottom: 8px;
      margin-top: 0px;
    }

    button {
      width: 100%;
      line-height: 24px;
      padding-left: 16px;
      padding-right: 16px;
    }
  }
`;

export const Content = styled.div`
  &&& {
    padding: 16px 24px;
    display: flex;
    flex-direction: column;
    gap: 15px;

    p {
      margin: 0;
      padding: 0;
    }

    ul {
      list-style: 'none';
      margin: 0;
      padding: 8px 0 0 0 !important;

      > li {
        display: flex;
        align-items: center;
        padding: 0;
        height: 35px;
        line-height: normal;
        ${FONT_WEIGHT_NORMAL};

        > img {
          margin-right: 4px;
          width: 24px;
        }
      }
    }
  }
`;

export const Header = styled.div<{ recommended: boolean }>`
  &&& {
    max-width: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    border-radius: 8px 8px 0 0;
    gap: 5px;
    ${() =>
      !isAmazonHost() &&
      css`
        gap: 8px;

        @media only screen and (max-width: 430px) {
          height: auto;
          gap: 4px;
        }
      `}

    .card-column:only-child & {
      height: auto;
    }

    ${() =>
      isAmazonHost() &&
      css`
        border-bottom: 1px solid ${TERTIARY_500};
      `};
    ${(props) => {
      let color = isAmazonHost() ? WHITE : NATIVE_GREY;
      if (props.recommended) {
        color = PRIMARY_500;
        if (isAmazonHost()) {
          color = PRIMARY_100;
        }
      }
      return css`
        background-color: ${color};
      `;
    }};
    color: ${() => (isAmazonHost() ? NEUTRAL_500 : PRIMARY_100)};
    padding: 24px;
    ${() =>
      isAmazonHost() &&
      css`
        padding: 16px 24px;
      `};

    h4 {
      font-size: 28px;
      line-height: 42px;
      margin: 0;
      padding: 0;
    }

    p {
      font-size: 20px;
      line-height: 30px;
      ${FONT_WEIGHT_LIGHT};
      margin: 0;
      padding: 0;
    }

    > .text {
      display: flex;
      flex-direction: column;
      gap: 5px;
    }
  }
`;

export const TagContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${() => css`
    > .tag {
      font-size: 12px;
      ${() => (isAmazonHost() ? FONT_WEIGHT_NORMAL : FONT_WEIGHT_REGULAR)};
      line-height: 12px;
      padding: 4px 8px;
      border-radius: 4px;

      &.recommended {
        background-color: ${() => (isAmazonHost() ? AMZ_SUCCESS : WHITE)};
        color: ${() => (isAmazonHost() ? WHITE : POSITIVE_500)};
      }

      &.no-video {
        background-color: ${() => (isAmazonHost() ? NEGATIVE_100 : WHITE)};
        color: ${() => (isAmazonHost() ? NEGATIVE_700 : NEGATIVE_500)};
      }

      &.not-compatible {
        background-color: ${() => (isAmazonHost() ? NEGATIVE_500 : WHITE)};
        color: ${() => (isAmazonHost() ? WHITE : NEGATIVE_500)};
      }
    }
  `}
`;
